import React from 'react'
import "../App.css";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Main from "../components/Main";


const Home = () => {
  return (
		<div id="home" style={{ overflowX: "hidden" }}>
			<Header />
			<Main />
			<Footer />
		</div>
	);
}

export default Home
